import * as THREE from "three";

/** A single opaque cylindrical emitter; no shell, core or specular glass layer. */
export function createLightFrame() {
  const group = new THREE.Group();
  // Inset each end by 0.25 so neighboring cylinders leave a small corner gap.
  const geometry = new THREE.CylinderGeometry(0.12, 0.12, 7.5, 24);
  const materials: THREE.ShaderMaterial[] = [];
  const positions = [[0, 4], [4, 0], [0, -4], [-4, 0]];
  for (let side = 0; side < 4; side++) {
    const material = new THREE.ShaderMaterial({
      uniforms: { radiance: { value: 0 }, ice: { value: new THREE.Color(0.72, 0.89, 1) } },
      vertexShader: `
        varying vec3 vNormal; varying vec3 vView;
        void main() {
          vec4 viewPosition=modelViewMatrix*vec4(position,1.0);
          vNormal=normalize(normalMatrix*normal);
          vView=-viewPosition.xyz;
          gl_Position=projectionMatrix*viewPosition;
        }`,
      fragmentShader: `
        uniform float radiance; uniform vec3 ice;
        varying vec3 vNormal; varying vec3 vView;
        void main() {
          float facing=clamp(dot(normalize(vNormal),normalize(vView)),0.0,1.0);
          float roundness=0.72+0.28*facing;
          float fog=exp(-pow(length(vView)*0.019,2.0));
          gl_FragColor=vec4(ice*max(0.0,radiance)*roundness*fog,1.0);
        }`,
    });
    const tube = new THREE.Mesh(geometry, material);
    tube.position.set(positions[side]![0]!, positions[side]![1]!, 0);
    tube.rotation.z = side % 2 ? 0 : Math.PI / 2;
    group.add(tube);
    materials.push(material);
  }
  return {
    group, geometry, materials,
    setEdgeLight(side: number, radiance: number, kick: number) {
      materials[side]!.uniforms.radiance!.value = radiance;
      materials[side]!.uniforms.ice!.value.setRGB(0.72 + kick * 0.12, 0.89 + kick * 0.06, 1);
    },
    dispose() { geometry.dispose(); materials.forEach(material => material.dispose()); },
  };
}
